export const identificationTypes = [
    {
     value:'',
     text :'Select ID type'
    }
    ,
    {
        value: 'Passport',
        text: 'Passport'
    },
    {
        value: 'National ID',
        text: 'National ID'
    },
    {
        value: 'Residence ID',
        text: 'Residence ID'
    }
    ,
    {
        value: 'Driving License',
        text: 'Driving License'
    }
]